import { apiClient } from './api-client'
import { API_ENDPOINTS } from '@/config/constants'
import {
  BillingConfig,
  GenerateInvoicesDto,
  Invoice,
  InvoiceDetail,
  InvoiceGenerationResult,
  UpdateBillingConfigDto,
} from '@/types/facturation.types'

export const facturationService = {
  getAll: async (): Promise<Invoice[]> => {
    return apiClient.get<Invoice[]>(API_ENDPOINTS.INVOICES.BASE)
  },

  getById: async (id: string): Promise<InvoiceDetail> => {
    return apiClient.get<InvoiceDetail>(API_ENDPOINTS.INVOICES.BY_ID(id))
  },

  getBillingConfig: async (): Promise<BillingConfig> => {
    return apiClient.get<BillingConfig>(API_ENDPOINTS.INVOICES.BILLING_CONFIG)
  },

  updateBillingConfig: async (data: UpdateBillingConfigDto): Promise<BillingConfig> => {
    return apiClient.patch<BillingConfig>(API_ENDPOINTS.INVOICES.BILLING_CONFIG, data)
  },

  generateInvoices: async (
    data: GenerateInvoicesDto
  ): Promise<InvoiceGenerationResult> => {
    return apiClient.post<InvoiceGenerationResult>(API_ENDPOINTS.INVOICES.GENERATE, data)
  },
}
